/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%] {\n  cursor: pointer; }\n\n.table-loading[_ngcontent-%COMP%] {\n  background-color: #000;\n  opacity: 0.85;\n  z-index: 10000 !important; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared-case/shared-case.component.scss.shim.ngstyle.js.pre-build-optimizer.js